import {CtxType} from "../init_ab_testing_instance";
import {IABTestConfiguration, IVariantConfigParams} from "../types/IABTestConfiguration";
import {specifyABTestVariant} from "../utils/ab_testing_ssr";

export const getABTestDataAction = (abTest: IABTestConfiguration, ctx: CtxType, domain: string, params?: IVariantConfigParams): string => {
    const variant = specifyABTestVariant(abTest, domain, ctx.req, ctx.meta, params);

    return `${abTest.id}.${variant}`;
};
import {CtxType} from "../init_ab_testing_instance";
import {IABTestConfiguration, IVariantConfigParams} from "../types/IABTestConfiguration";
import {specifyABTestVariant} from "../utils/ab_testing_ssr";

export const getABTestDataAction = (abTest: IABTestConfiguration, ctx: CtxType, domain: string, params?: IVariantConfigParams): string => {
    const variant = specifyABTestVariant(abTest, domain, ctx.req, ctx.meta, params);

    return `${abTest.id}.${variant}`;
};
